import { FC, useEffect, useState } from 'react'
import UnitApi from '../../../../infrastructure/api/UnitApi'
import { IUnitModel } from '../../../../models/responses/UnitModel'
import { PagedResponseModel } from '../../../../models/responses/PagedResponseModel'
import { IPaginationFilter } from '../../../../models/requests/PaginationFilter'
import { GenericTable } from '../../../components/tables/GenericTable'
import { TableHelperButtons } from '../../../components/buttons/TableHelperButtons'
import { TableHelperButtonEnum } from '../../../enums/TableHelperButtonEnum'
import { useParams } from 'react-router-dom'
import { UnitTypeEnum } from '../../../../enums/UnitTypeEnum'

type Props = {
  onClickItem: (itemId: any, itemName: string, type: string) => void
  refresh: number
}

const UnitListModal: FC<Props> = ({ onClickItem, refresh }) => {
  const [units, setUnits] = useState<PagedResponseModel<IUnitModel[]>>()
  const [pageNumber, setPageNumber] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [searchText, setSearchText] = useState('')
  const [sort, setSort] = useState('title_asc')
  const { type } = useParams<any>()

  useEffect(() => {
    const paginationFilter: IPaginationFilter = {
      page: pageNumber,
      size: pageSize,
      orderBy: sort,
      search: searchText,
    }

    let unitType = UnitTypeEnum[type]
    async function getUnits() {
      var response = await UnitApi.GetUnits(parseInt(unitType), paginationFilter)
      setUnits(response.data)
    }
    getUnits()
  }, [refresh, pageNumber, pageSize, searchText, sort, type])

  return (
    <>
      <GenericTable
        title='Units'
        data={units?.items}
        currentTotalRecords={units?.totalRecords!!}
        currentPageNumber={units?.pageNumber!!}
        columns={[
          {
            label: '#',
            name: '#',
            options: {
              customBodyRenderLite: (dataIndex) => {
                return <>{(pageNumber - 1) * pageSize + ++dataIndex}</>
              },
              sort: false,
              viewColumns: false
            },
          },
          {
            label: 'Name',
            name: 'title',
            options: {
              customBodyRender: (value) => {
                return <b>{value}</b>
              },
            },
          },
          { label: 'Explanation', name: 'explanation' },
          { label: 'Present Level', name: 'levelName', options: { sort: false } },
          { label: 'Question Frequency', name: 'questionFrequency' },
          {
            label: '#',
            name: 'Id',
            options: {
              customHeadLabelRender: (options) => {
                return (
                  <div className='d-flex justify-content-end flex-shrink-0'>{options.label}</div>
                )
              },
              customBodyRenderLite: (dataIndex) => {
                return (
                  <TableHelperButtons
                    itemId={units?.items[dataIndex]?.id!!}
                    itemParam={units?.items[dataIndex]?.title!!}
                    types={[TableHelperButtonEnum.Update, TableHelperButtonEnum.Delete]}
                    onClickItem={onClickItem}
                  />
                )
              },
              filter: false,
              sort: false,
              viewColumns: false,
            },
          },
        ]}
        customOptions={{
          rowsPerPage: pageSize,
          customTableBodyFooterRender: (opts) => {
            return <div></div>
          },
        }}
        setPageNumber={setPageNumber}
        setPageSize={setPageSize}
        setSearchText={setSearchText}
        setSort={setSort}
      />
    </>
  )
}

export { UnitListModal }
